export const sortCellsByDistance = (cellsChanged, startPos) => {
  return cellsChanged.sort((a, b) => {
    const distA = Math.abs(a[0] - startPos[0]) + Math.abs(a[1] - startPos[1]);
    const distB = Math.abs(b[0] - startPos[0]) + Math.abs(b[1] - startPos[1]);
    return distA - distB;
  });
};